<script setup lang="ts">
import { DtModal } from '@dialpad/dialtone/vue3/lib/modal';
import { updateShow } from './modals';
import { DATA_QA as MODAL_WRAPPER_DATA_QA } from '@/app/components/modal/modal-wrapper.constants';
import { onMounted, ref } from 'vue';

const show = ref(false);

onMounted(() => {
  show.value = true;
});
</script>
<template>
  <DtModal
    :data-qa="MODAL_WRAPPER_DATA_QA.DIALOG"
    title="Not implemented"
    :close-button-props="{
      ariaLabel: $t('MODAL_CLOSE_ARIA_LABEL'),
      'data-qa': MODAL_WRAPPER_DATA_QA.CLOSE,
    }"
    :show="show"
    content-class="d-p4 d-mn4"
    @update:show="updateShow"
  >
    Not implemented
  </DtModal>
</template>
